// src/components/ui/LoadFailureCard.jsx
// Bounded fallback for the post-login loading states. Rendered instead of an
// endless spinner once a profile / organization load has stalled, so the user
// always has a way out (Retry = full reload, Sign out = clear session).

import { AlertCircle } from 'lucide-react';

export function LoadFailureCard({ title = "We couldn't load your profile", detail, onSignOut }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-sm bg-white rounded-lg shadow-md p-6 text-center">
        <AlertCircle className="w-10 h-10 text-red-500 mx-auto mb-3" />
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        {detail && <p className="mt-2 text-sm text-gray-600 break-words">{detail}</p>}
        <div className="mt-5 flex justify-center gap-3">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="px-4 py-2 rounded-lg bg-primary text-white hover:opacity-90"
          >
            Retry
          </button>
          <button
            type="button"
            onClick={onSignOut}
            className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoadFailureCard;
